<h2 mat-dialog-title>Upload Source Documents</h2>
<mat-dialog-content>
  <app-file-selector
    [allowedExtensions]="supportedFileExtensions"
    [multiple]="true"
    (filesChanged)="onFilesChanged($event)">
  </app-file-selector>
</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
  <button mat-button [disabled]="isSubmitting" (click)="onCancel()">Cancel</button>

  <app-loader-button
    class="save-button"
    mat-flat-button
    [disabled]="files.length === 0"
    [loading]="isSubmitting"
    color="primary"
    (click)="onSave()"
    >Confirm</app-loader-button
  >
</mat-dialog-actions>
